module.exports = "/dist/fonts/shield-check-solid.svg";